import { render, staticRenderFns } from "./okoskabet.vue?vue&type=template&id=6b11a021&"
import script from "./okoskabet.vue?vue&type=script&lang=js&"
export * from "./okoskabet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports